"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const client_1 = require("react-dom/client");
function Admin({ initialLoggedIn }) {
    const [loggedIn, setLoggedIn] = react_1.default.useState(initialLoggedIn);
    const [loginError, setLoginError] = react_1.default.useState(false);
    const handleLogin = async () => {
        const usernameInput = document.getElementById('username');
        const passwordInput = document.getElementById('password');
        const response = await fetch('/api/v1/admin/login', {
            method: 'POST',
            body: JSON.stringify({
                username: usernameInput.value,
                password: passwordInput.value
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        });
        passwordInput.value = '';
        const success = await response.json();
        setLoggedIn(success);
        setLoginError(!success);
    };
    const handleLogout = async () => {
        await fetch('/api/v1/admin/logout', {
            method: 'POST',
            credentials: 'same-origin'
        });
        setLoggedIn(false);
    };
    return (loggedIn ?
        react_1.default.createElement(AdminScreen, { onLogout: handleLogout }) :
        react_1.default.createElement(LoginScreen, { onLogin: handleLogin, error: loginError }));
}
function Popup({ children, visible, title }) {
    return (react_1.default.createElement("div", { className: "popupBackground", style: { display: visible ? 'block' : 'none' } },
        react_1.default.createElement("div", { className: "popup" },
            title && react_1.default.createElement("div", { className: "popupTitle" }, title),
            children)));
}
function BusyPopup({ visible, message }) {
    return (react_1.default.createElement(Popup, { visible: visible, title: message },
        react_1.default.createElement("img", { src: "/icons/busy.gif" })));
}
function CreateSoftwarePopup({ visible, onClose, onCreate }) {
    (0, react_1.useEffect)(() => {
        if (visible) {
            const softwareNameInput = document.getElementById('createSoftwareName');
            softwareNameInput.focus();
        }
    }, [visible]);
    const handleCreate = () => {
        const softwareNameInput = document.getElementById('createSoftwareName');
        const metadataTemplateInput = document.getElementById('createSoftwareTemplate');
        if (softwareNameInput.value === '') {
            alert('Software name cannot be empty');
            return;
        }
        try {
            const templateJson = JSON.parse(metadataTemplateInput.value);
            onCreate(softwareNameInput.value, templateJson);
            metadataTemplateInput.value = '';
            softwareNameInput.value = '';
        }
        catch (e) {
            alert('Metadata template is not a valid JSON');
            return;
        }
    };
    return (react_1.default.createElement(Popup, { visible: visible, title: "Create software" },
        react_1.default.createElement("div", { className: "popupMessageContainer" },
            react_1.default.createElement("label", { htmlFor: "createSoftwareName" }, "Software name:"),
            react_1.default.createElement("input", { id: "createSoftwareName", placeholder: "Software name", type: "text" }),
            react_1.default.createElement("label", { htmlFor: "createSoftwareTemplate" }, "Metadata template (JSON):"),
            react_1.default.createElement("textarea", { id: "createSoftwareTemplate", cols: 40, rows: 5 })),
        react_1.default.createElement("div", { className: "popupButtons" },
            react_1.default.createElement("button", { onClick: handleCreate }, "Create"),
            react_1.default.createElement("button", { onClick: onClose }, "Cancel"))));
}
function CreateBranchPopup({ visible, onClose, onCreate, software }) {
    (0, react_1.useEffect)(() => {
        if (visible) {
            const branchNameInput = document.getElementById('createBranchName');
            branchNameInput.focus();
        }
    }, [visible]);
    const handleCreate = () => {
        const branchNameInput = document.getElementById('createBranchName');
        if (branchNameInput.value == '') {
            alert('Branch name cannot be empty');
            return;
        }
        onCreate(branchNameInput.value);
        branchNameInput.value = '';
    };
    return (react_1.default.createElement(Popup, { visible: visible, title: `Create branch for ${software}` },
        react_1.default.createElement("div", { className: "popupMessageContainer" },
            react_1.default.createElement("label", { htmlFor: "createBranchName" }, "Branch name:"),
            react_1.default.createElement("input", { id: "createBranchName", placeholder: "Branch name", type: "text" })),
        react_1.default.createElement("div", { className: "popupButtons" },
            react_1.default.createElement("button", { onClick: handleCreate }, "Create"),
            react_1.default.createElement("button", { onClick: onClose }, "Cancel"))));
}
function UploadPopup({ visible, onClose, onUpload, software, branch, metadataTemplate }) {
    (0, react_1.useEffect)(() => {
        if (visible) {
            const uploadVersion = document.getElementById('uploadVersion');
            uploadVersion.focus();
        }
    }, [visible]);
    (0, react_1.useEffect)(() => {
        if (metadataTemplate) {
            const uploadMetadataInput = document.getElementById('fileMetadata');
            uploadMetadataInput.value = JSON.stringify(metadataTemplate, null, 2);
        }
    }, [metadataTemplate]);
    const handleUpload = () => {
        var _a;
        const uploadVersionInput = document.getElementById('uploadVersion');
        const uploadFileInput = document.getElementById('uploadFile');
        const uploadMetadataInput = document.getElementById('fileMetadata');
        if (uploadVersionInput.value === '') {
            alert('Version cannot be empty');
            return;
        }
        if (((_a = uploadFileInput.files) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            alert('Please select a file to upload');
            return;
        }
        if (uploadMetadataInput.value === '') {
            alert('Metadata cannot be empty');
            return;
        }
        try {
            const metadataJson = JSON.parse(uploadMetadataInput.value);
            onUpload(uploadVersionInput.value, uploadFileInput.files[0], JSON.stringify(metadataJson));
            uploadVersionInput.value = '';
            uploadFileInput.value = '';
            uploadMetadataInput.value = '';
        }
        catch (error) {
            alert('Metadata is not a valid JSON');
            return;
        }
    };
    return (react_1.default.createElement(Popup, { visible: visible, title: "Upload version" },
        react_1.default.createElement("div", { className: "popupMessageContainer" },
            react_1.default.createElement("label", { htmlFor: "uploadVersion" }, "Version:"),
            react_1.default.createElement("input", { id: "uploadVersion", placeholder: "Version", type: "text" }),
            react_1.default.createElement("label", { htmlFor: "uploadFile" }, "Update file:"),
            react_1.default.createElement("input", { id: "uploadFile", type: "file" }),
            react_1.default.createElement("label", { htmlFor: "fileMetadata" }, "Metadata (JSON):"),
            react_1.default.createElement("textarea", { id: "fileMetadata", cols: 40, rows: 5 })),
        react_1.default.createElement("div", { className: "popupButtons" },
            react_1.default.createElement("button", { onClick: handleUpload }, "Upload"),
            react_1.default.createElement("button", { onClick: onClose }, "Cancel"))));
}
function DeletePopup({ visible, onClose, onDelete, software, version, branch }) {
    (0, react_1.useEffect)(() => {
        if (visible) {
            const deleteConfirm = document.getElementById('deleteConfirm');
            deleteConfirm.focus();
        }
    }, [visible]);
    const itemName = (version && 'Version') || (branch && 'Branch') || 'Software';
    const handleDelete = () => {
        var _a;
        const deleteConfirm = document.getElementById('deleteConfirm');
        const confirmInput = deleteConfirm.value;
        const expected = (_a = version !== null && version !== void 0 ? version : branch) !== null && _a !== void 0 ? _a : software;
        if (confirmInput !== expected) {
            alert(`${itemName} does not match.`);
            return;
        }
        deleteConfirm.value = '';
        onDelete();
    };
    return (react_1.default.createElement(Popup, { visible: visible, title: `Delete ${itemName.toLowerCase()}?` },
        react_1.default.createElement("div", { className: "popupMessageContainer" },
            react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: (version && `You are about to delete version <b>${version}</b> of <b>${software}</b> on branch <b>${branch}</b>.`) ||
                        (branch && `You are about to delete branch <b>${branch}</b> of software <b>${software}</b>.`) ||
                        `You are about to delete software <b>${software}</b>.`
                } }),
            react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: (version && 'Are you sure you want to delete this version?') ||
                        (branch && 'Are you sure you want to delete this branch?') ||
                        'Are you sure you want to delete this software?'
                } }),
            react_1.default.createElement("span", { dangerouslySetInnerHTML: { __html: (version && `Enter the version name <b>${version}</b> to confirm:`) ||
                        (branch && `Enter the branch name <b>${branch}</b> to confirm:`) ||
                        `Enter the software name <b>${software}</b> to confirm:`
                } }),
            react_1.default.createElement("input", { id: "deleteConfirm", style: { alignSelf: 'center', marginTop: '8px' }, type: "text" })),
        react_1.default.createElement("div", { className: "popupButtons" },
            react_1.default.createElement("button", { onClick: handleDelete }, "Delete"),
            react_1.default.createElement("button", { onClick: onClose }, "Cancel"))));
}
function UpdateTreeView({ tree, onDelete, onUpload, onCreateSoftware, onCreateBranch }) {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { style: { marginTop: '16px' } },
            react_1.default.createElement("a", { href: "#", onClick: onCreateSoftware }, "Create software")),
        !tree && react_1.default.createElement("p", null, "Loading\u2026"),
        tree && Object.keys(tree).map(software => (react_1.default.createElement("div", { key: software },
            react_1.default.createElement("div", { className: "itemContainer", style: { marginTop: '16px' } },
                react_1.default.createElement("span", { style: { fontSize: '1.5em' } }, software),
                react_1.default.createElement("img", { title: `Create new branch for software ${software}`, className: "itemIcon clickable", src: "/icons/create-branch.png", onClick: () => onCreateBranch(software) }),
                Object.keys(tree[software]).length === 0 &&
                    react_1.default.createElement("img", { title: `Delete software ${software}`, className: "itemIcon clickable", src: "/icons/delete.png", onClick: () => onDelete(software) })),
            Object.keys(tree[software]).map(branch => (react_1.default.createElement("div", { key: branch, style: { marginLeft: '20px' } },
                react_1.default.createElement("div", { className: "itemContainer" },
                    react_1.default.createElement("img", { src: "/icons/branch.png", className: "itemIcon" }),
                    react_1.default.createElement("span", { style: { fontSize: '1.2em' } }, branch),
                    react_1.default.createElement("img", { title: `Upload version to ${software} branch ${branch}`, className: "itemIcon clickable", src: "/icons/upload.png", onClick: () => onUpload(software, branch) }),
                    Object.keys(tree[software][branch]).length === 0 &&
                        react_1.default.createElement("img", { title: `Delete branch ${branch} of software ${software}`, className: "itemIcon clickable", src: "/icons/delete.png", onClick: () => onDelete(software, branch) })),
                Object.keys(tree[software][branch]).map(version => (react_1.default.createElement("div", { className: "versionContainer", key: version },
                    react_1.default.createElement("div", { className: "itemContainer version", key: version },
                        react_1.default.createElement("img", { className: "itemIcon", src: "/icons/file.png" }),
                        react_1.default.createElement("span", null, version),
                        react_1.default.createElement("a", { href: `/api/v1/update/download/${software}/${branch}/${version}` },
                            react_1.default.createElement("img", { title: `Download ${software} version ${version} on branch ${branch}`, className: "itemIcon clickable hoverIcon", src: "/icons/download.png" })),
                        react_1.default.createElement("img", { title: `Delete ${software} version ${version} on branch ${branch}`, className: "itemIcon clickable hoverIcon", src: "/icons/delete.png", onClick: () => onDelete(software, branch, version) })),
                    react_1.default.createElement("div", { className: "versionDetails" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("span", null, "Metadata:"),
                            react_1.default.createElement("pre", null, JSON.stringify(tree[software][branch][version].metadata, null, 2))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("span", null, "File info:"),
                            react_1.default.createElement("span", null, tree[software][branch][version].fileName),
                            react_1.default.createElement("span", null,
                                (tree[software][branch][version].size / 1024 / 1024).toFixed(2),
                                " MB"))))))))))))));
}
function AdminScreen({ onLogout }) {
    const [updateTree, setUpdateTree] = react_1.default.useState(undefined);
    const [busyState, setBusyState] = react_1.default.useState({ busy: false });
    const [deleteState, setDeleteState] = react_1.default.useState({ visible: false });
    const [uploadState, setUploadState] = react_1.default.useState({ visible: false });
    const [creatingSoftware, setCreatingSoftware] = react_1.default.useState(false);
    const [createBranchState, setCreateBranchState] = react_1.default.useState({ visible: false });
    const [version, setVersion] = react_1.default.useState();
    react_1.default.useEffect(() => {
        fetch('/api/v1/admin/version', { credentials: 'same-origin' })
            .then(res => res.text())
            .then(text => setVersion(text));
        fetch('/api/v1/admin/updateTree', { credentials: 'same-origin' })
            .then(res => res.json())
            .then(json => setUpdateTree(json));
    }, []);
    const handleDelete = (software, branch, version) => {
        setDeleteState({ visible: true, software, branch, version });
    };
    const handleUpload = (software, branch) => {
        fetch(`/api/v1/admin/metadataTemplate/${software}`, { credentials: 'same-origin' }).then(async (res) => {
            const metadataTemplate = await res.json();
            setUploadState({ visible: true, software, branch, metadataTemplate });
        });
    };
    const handleCreateSoftware = () => {
        setCreatingSoftware(true);
    };
    const handleCreateBranch = (software) => {
        setCreateBranchState({ visible: true, software });
    };
    const refreshTree = () => {
        fetch('/api/v1/admin/updateTree', { credentials: 'same-origin' })
            .then(res => res.json())
            .then(json => {
            setUpdateTree(json);
        });
    };
    const handleDeleteConfirm = () => {
        const software = deleteState.software;
        const branch = deleteState.branch;
        const version = deleteState.version;
        const url = (version && `/api/v1/admin/updates/${software}/${branch}/${version}`) ||
            (branch && `/api/v1/admin/updates/${software}/${branch}`) ||
            `/api/v1/admin/updates/${software}`;
        setDeleteState({ visible: false });
        setBusyState({ busy: true, message: 'Deleting…' });
        fetch(url, { method: 'DELETE', credentials: 'same-origin' }).then(() => {
            setBusyState({ busy: false });
            refreshTree();
        });
    };
    const handleCreateSoftwareConfirm = (software, metadataTemplate) => {
        setCreatingSoftware(false);
        setBusyState({ busy: true, message: 'Creating software…' });
        fetch(`/api/v1/admin/updates/${software}`, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify(metadataTemplate)
        }).then(() => {
            setBusyState({ busy: false });
            refreshTree();
        });
    };
    const handleCreateBranchConfirm = (branch) => {
        setCreateBranchState({ visible: false });
        setBusyState({ busy: true, message: 'Creating branch…' });
        fetch(`/api/v1/admin/updates/${createBranchState.software}/${branch}`, {
            method: 'POST'
        }).then(() => {
            setBusyState({ busy: false });
            refreshTree();
        });
    };
    const handleUploadConfirm = (version, file, metadata) => {
        setUploadState({ visible: false });
        setBusyState({ busy: true, message: 'Uploading…' });
        const formData = new FormData();
        formData.append('version', version);
        formData.append('file', file);
        formData.append('metadata', metadata);
        fetch(`/api/v1/admin/updates/${uploadState.software}/${uploadState.branch}/${version}`, {
            method: 'POST',
            body: formData
        }).then(() => {
            setBusyState({ busy: false });
            refreshTree();
        });
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h1", null, "BIOX OTA / X2 Online Updates"),
        react_1.default.createElement("hr", null),
        react_1.default.createElement("div", { className: "helpContainer" },
            react_1.default.createElement("ul", { style: { listStyleType: 'none' } },
                react_1.default.createElement("li", null, "Updates are ordered by software name, branch and version"),
                react_1.default.createElement("li", null, "Software and branches can only be deleted when empty"),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("img", { src: "/icons/create-branch.png" }),
                    "Create branch"),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("img", { src: "/icons/upload.png" }),
                    "Upload version"),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("img", { src: "/icons/download.png" }),
                    "Download version"),
                react_1.default.createElement("li", null,
                    react_1.default.createElement("img", { src: "/icons/delete.png" }),
                    "Delete version, branch or software"))),
        react_1.default.createElement(UpdateTreeView, { tree: updateTree, onDelete: handleDelete, onUpload: handleUpload, onCreateSoftware: handleCreateSoftware, onCreateBranch: handleCreateBranch }),
        react_1.default.createElement("div", { style: { marginTop: '16px' } },
            react_1.default.createElement("span", { style: { float: 'right', marginRight: '4em' } },
                "v",
                version),
            react_1.default.createElement("a", { href: "#", onClick: onLogout }, "Logout")),
        react_1.default.createElement(BusyPopup, { visible: busyState.busy, message: busyState.message }),
        react_1.default.createElement(DeletePopup, { visible: deleteState.visible, onClose: () => setDeleteState({ visible: false }), onDelete: handleDeleteConfirm, software: deleteState.software, branch: deleteState.branch, version: deleteState.version }),
        react_1.default.createElement(UploadPopup, { visible: uploadState.visible, onClose: () => setUploadState({ visible: false }), onUpload: handleUploadConfirm, metadataTemplate: uploadState.metadataTemplate }),
        react_1.default.createElement(CreateSoftwarePopup, { visible: creatingSoftware, onClose: () => setCreatingSoftware(false), onCreate: handleCreateSoftwareConfirm }),
        react_1.default.createElement(CreateBranchPopup, { visible: createBranchState.visible, onClose: () => setCreateBranchState({ visible: false }), onCreate: handleCreateBranchConfirm, software: createBranchState.software })));
}
function LoginScreen({ onLogin, error }) {
    (0, react_1.useEffect)(() => {
        var _a;
        (_a = document.getElementById('username')) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("h1", null, "BIOX OTA / X2 Online Login"),
        react_1.default.createElement("hr", null),
        react_1.default.createElement("div", { className: 'inputContainer' },
            react_1.default.createElement("label", { style: { display: 'block' }, htmlFor: "username" }, "Username:"),
            react_1.default.createElement("input", { type: "text", id: "username", name: "username" })),
        react_1.default.createElement("div", { className: 'inputContainer' },
            react_1.default.createElement("label", { style: { display: 'block' }, htmlFor: "password" }, "Password:"),
            react_1.default.createElement("input", { type: "password", id: "password", name: "password" })),
        react_1.default.createElement("div", { className: 'inputContainer' },
            react_1.default.createElement("button", { type: "submit", onClick: onLogin }, "Login")),
        error && react_1.default.createElement("p", { id: "errorMessage", style: { color: 'red' } }, "Invalid username or password")));
}
(async function init() {
    const response = await fetch('/api/v1/admin/login', { credentials: 'same-origin' });
    const loggedIn = await response.json();
    (0, client_1.createRoot)(document.getElementById('root')).render(react_1.default.createElement(Admin, { initialLoggedIn: loggedIn }));
})();
//# sourceMappingURL=Admin.js.map